<template>
	<div class="special-menu">
		<div class="special-menu.tab">
			<span>特价类型</span>
			<ul>
				 <li :class="{'+active-tab-special':index == curretnTab}" v-for="(tab,index) in tabs" :key="index" @click="switchTabs(tab.apiUrl,index)">{{tab.name}}</li>
			</ul>
			
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				tabs:[
					{name:'商标',apiUrl:'IPR_Trademark'},
					{name:'版权',apiUrl:'IPR_Copyright'},
					{name:'专利',apiUrl:'IPR_Patent'},
				],
				curretnTab:0
			}
		},
		methods:{
			switchTabs(apiUrl,index){
				this.curretnTab = index
				this.$emit('updateSpecial',apiUrl)
			}
		}
	}
</script>

<style lang="scss">
	@include component(special-menu){
		width: 100%;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		color: #333333;
		background: #fff;
		padding-right: 18px;
		@include part(tab){
			display: flex;
			span {
				display: flex;
				width: 120px;
				min-height: 73px;
				text-align: center;
				line-height: 73px;
				border-right: 1px solid #E2E2E2;
				//align-items: center;
				justify-content: center;
				
			}
			ul {
				width: calc(100% - 190px);
				display: flex;
				justify-content: flex-start;
				align-items: center;
			    flex-wrap: wrap;
				//padding: 10px 0;
				padding-left: 18px;
				height:73px;
				overflow:hidden;
			
				li {
					padding: 0 18px;
					cursor: pointer;
					text-align: left;
					height:73px;
					line-height:73px;
			
					&:hover {
						color: #2278FC;
					}
			
				}
			}
		}
		@include tweak(active-tab-special){
			color: #2278FC;
		}
	}
</style>
